
import CheckboxIcon from '~/assets/images/checkbox.svg?inline'

export default {
  components: {
    CheckboxIcon,
  },
  inject: {
    formControlIds: {
      default: () => ({}),
    },
  },
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    indeterminate(newValue) {
      this.$refs.checkbox.indeterminate = newValue
    },
  },
  mounted() {
    this.$refs.checkbox.indeterminate = this.indeterminate
  },
}
